import { PAYMENT_FORM_MESSAGES, PaymentFormMessages } from "./payment-form.messages";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../../tables/columns.messages";

export type StatementTabMessages = TableColumnsMessages &
  PaymentFormMessages & {
    dateColumn: string;
    transactionColumn: string;
    descriptionColumn: string;
    valueColumn: string;
    balanceColumn: string;
    balanceFooter: string;
    csv: string;
    pdf: string;
    exportStatementButtonLabel: string;
    withdrawButtonLabel: string;
    downloadPdfError: string;
    downloadCsvError: string;
    noTransactionsInPeriod: string;
  };

export const STATEMENT_TAB_MESSAGES: StatementTabMessages = {
  ...TABLE_COLUMNS_MESSAGES,
  ...PAYMENT_FORM_MESSAGES,
  dateColumn: "Data",
  transactionColumn: "Transação",
  descriptionColumn: "Descrição",
  valueColumn: "Valor",
  balanceColumn: "Saldo",
  balanceFooter: "Saldo Final",
  csv: ".csv",
  pdf: ".pdf",
  exportStatementButtonLabel: "Exportar",
  withdrawButtonLabel: "Sacar",
  downloadPdfError: "Houve um erro ao baixar o extrato.",
  downloadCsvError: "Houve um erro ao exportar o extrato em CSV.",
  noTransactionsInPeriod: "Não existem movimentações no período informado.",
};
